import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class CampaignManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/mobile-app/campaigns',
      params,
      paramsSerializer: qs.stringify,
    });

  post = (data) =>
    this.request({
      method: 'POST',
      url: '/mobile-app/campaigns',
      data,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/mobile-app/campaigns/${id}`,
    });

  getRecipients = (id, params) =>
    this.request({
      method: 'GET',
      url: `/mobile-app/campaigns/${id}/recipients`,
      params,
      paramsSerializer: qs.stringify,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/mobile-app/campaigns/${id}`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/mobile-app/campaigns/${id}`,
    });

  getWeeklyPerformance = () =>
    this.request({
      method: 'GET',
      url: '/mobile-app/weekly-campaigns-performance',
    });

  getStats = (data) =>
    this.request({
      method: 'POST',
      url: '/mobile-app/stats',
      data,
    });

  activate = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/mobile-app/campaigns/${id}/activate`,
      data,
    });

  sendTestCampaign = (data) =>
    this.request({
      method: 'POST',
      url: '/mobile-app/send-test-campaign',
      data,
    });

  getUnavailability = () =>
    this.request({
      method: 'GET',
      url: '/mobile-app/campaigns-unavailability',
    });
}
